module.exports = __webpack_public_path__ + "static/media/diners.f7c3d8a1.png";